import { Z_INDEX, FONT_SIZE_SMALL } from "../../../../../constants/constants";
import { PNL_COLOR_SQUARE_BORDER } from "../../../../Nav/ColorLegend";
import {
  TREND_CHART_BAR_PADDING_HZ,
  TREND_CHART_BAR_WIDTH,
  TOOLTIP_OFFSET_TOP,
  BARSTACK_PADDING_TOP,
} from "../../TrendChartStyles";

import styled from "styled-components/macro";
import { darkModeTextColor } from "constants/colors";

export const TrendChartBarStyles = styled.div<{
  $containerWidth?: number;
  $isDarkMode?: boolean;
  $isSafari?: boolean;
  $safariBarAndLabelsHeight?: number;
  $shouldHideProfitCategories?: boolean;
}>`
  color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
  &:hover {
    .trendChartBar {
      opacity: 0.5;
    }
  }
  .titleLabel > div {
    transition: all 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .topBarstack {
    padding-top: ${BARSTACK_PADDING_TOP}px;
  }
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: ${TREND_CHART_BAR_WIDTH + 2 * TREND_CHART_BAR_PADDING_HZ}px;
  max-width: ${TREND_CHART_BAR_WIDTH + 2 * TREND_CHART_BAR_PADDING_HZ}px;
  .tooltipContentWrapper {
    &:not(.pointerEventsEnabled) * {
      pointer-events: none;
    }
    width: 100%;
    left: 0;
    z-index: ${Z_INDEX.L6};
    position: relative;
    box-sizing: border-box;
    .tooltipContent {
      font-size: ${FONT_SIZE_SMALL - 2}px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      white-space: nowrap;
      position: absolute;
      top: ${-TOOLTIP_OFFSET_TOP}px;
      left: 0;
      box-sizing: border-box;
      padding: 0.5em;
      text-align: center;
      .timeRange {
        margin-bottom: 1em;
      }
      .metric {
        margin-bottom: 1em;
        margin-top: 1em;
        .title {
          margin-bottom: 0.5em;
        }
      }
      .rollupDetails {
        position: relative;

        .pnlRow {
          min-height: 1.6em;
          padding-bottom: 0.25em;
          &.unplanned,
          .producing {
            padding-bottom: 0;
          }
          display: flex;
          flex-direction: column;
          &:hover {
            opacity: 0.5 !important;
          }
          .percent {
            display: flex;
            justify-content: flex-end;
            font-size: 0.8em;
            min-height: 1.2em;

            &.zero {
              opacity: 0.2;
            }
          }
          .colorAndTime {
            display: flex;
            align-items: center;
            line-height: 1.2em;
            justify-content: flex-start;
            .pnlColorSquare {
              margin-right: 0.5em;
              box-sizing: border-box;
              border: ${PNL_COLOR_SQUARE_BORDER};
              min-width: 12px;
              min-height: 12px;
              width: 12px;
              height: 12px;
            }
            .pnlHoursMinutes {
              width: 100%;
              justify-content: flex-end;
              display: flex;
              .hours {
                margin-right: 0.5em;
              }
              .hours,
              .minutes {
                &.zero {
                  opacity: 0.2;
                }
              }
            }
          }
        }
      }
    }
  }
`;
